import { TablePagination } from '@mui/material';
import { TextBlock } from '../../../Atoms/Text';
import { INVOICE_LINES_PER_PAGE, showingCaption } from './InvoiceView.calc';

/** How many lines are showing out of all of them, with the page controls. */
export const InvoiceLinesPager = ({
  shown,
  total,
  page,
  onPageChange
}: {
  shown: number;
  total: number;
  page: number;
  onPageChange: (page: number) => void;
}) => (
  <div className="flex items-center justify-between">
    <TextBlock
      size="xs"
      color="grey6">
      {showingCaption(shown, total)}
    </TextBlock>
    <TablePagination
      component="div"
      count={total}
      page={page}
      rowsPerPage={INVOICE_LINES_PER_PAGE}
      rowsPerPageOptions={[]}
      onPageChange={(_event, next) => onPageChange(next)}
    />
  </div>
);
